export default __webpack_public_path__ + "static/10-e9f13c190576e957dec60d44bcfa17c4.png";